<input
	class="input {{ className }}"
	max="{{ max ? max : undefined }}"
	min="{{ min ? min : undefined }}"
	step="{{ step ? step : undefined }}"
	[attr.maxlength]="maxLength ? maxLength : null"
	[disabled]="disabled"
	[placeholder]="placeholder"
	[readonly]="readonly"
	[type]="type"
	[value]="value"
	(blur)="onBlur($event)"
	(input)="onChange($event)"
/>

@if (maxLength) {
	<character-limit
		class="character-limit"
		[current]="value | numberOfCharactersPipe"
		[max]="maxLength"
	/>
}

@if (!errorMessageHidden && control?.invalid) {
	<div class="error-container">
		<div class="error">
			@if (errorMessage || errorsTemplate) {
				<mat-icon class="error__icon" svgIcon="ic-close-small" />
			}
			@if (!errorsTemplate && errorMessage) {
				<span class="error__text">{{ errorMessage }}</span>
			}
			<ng-template
				[ngTemplateOutlet]="errorsTemplate"
				[ngTemplateOutletContext]="{ errors: control?.errors }"
			/>
		</div>
	</div>
}
